// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/Drawer.scss
// module id = ./src/styles/Drawer.scss
// module chunks = 0